<template>
    <div>
        <HeaderComponent />
        <div class="course-support container text-center">
            <div class="row">
                <div class="col field">
                    <label for="productvariantId">ProductVariant ID</label>
                    <input type="text" id="productvariantId" v-model="productVariantId" placeholder="Enter ProductVariantID" />
                </div>
                <div class="col field">
                    <label for="productTitle">Product Title</label>
                    <input type="text" id="productTitle" v-model="productTitle" placeholder="Enter Product Title" />
                </div>
            </div>
            <div class="row">
                <div class="col field">
                    <label for="contentId">Content ID</label>
                    <input type="text" id="contentId" v-model="contentId" placeholder="Enter Content ID" />
                </div>
                <div class="col field">
                    <label for="tenants">Tenants</label>
                    <v-select v-model="selectedTenant" :options="tenants" label="name" placeholder="Select TenantID" />
                </div>
            </div>
            <div class="fetch-parent-button row mt-3">
                <button @click="fetchData" class="fetch-button" :disabled="isLoading">
                    <b-spinner v-if="isLoading" small type="grow"></b-spinner>
                    <span v-else>Fetch</span>
                </button>
            </div>
        </div>
        <div v-if="isLoading" class="text-center mt-4">
            <b-spinner></b-spinner>
            <p>Fetching course data...</p>
        </div>
        <CourseSupportDataTable :courseData="courseData" :tenantId="selectedTenant?.name" />
    </div>
</template>
<script>
import HeaderComponent from '../Layout/HeaderComponent.vue';
import { GetAllTenants } from '../../Helper/TenantApiHelper';
import {GetCourseDataByTenantID} from '../../Helper/ContentApiHelper';
import CourseSupportDataTable from './CourseSupportDataTable.vue';
export default{
    name:'CourseSupport',
    data(){
        return{
            productVariantId:'',
            productTitle:'',
            contentId:'',
            tenants: [],
            selectedTenant: null,
            courseData:[],
            isLoading: false
        };
    },
    components:{
        HeaderComponent,CourseSupportDataTable
    },
    methods: {
        async getAllTenant() {
            try {
                const tenants = await GetAllTenants();
                this.tenants = tenants.map(tenant => ({ value: tenant.id, name: tenant.name }));
            } catch (error) {
                console.error(error);
            }
        },
        async fetchData() {
            try {
                if (!this.selectedTenant) {
                    this.$toasted.error(
                        "Please select a Tenant. It is required.", {
                            icon: "exclamation-triangle",
                            theme: "outline",
                            position: "bottom-center",
                            singleton: true,
                            duration: 3000,
                        }
                    );
                    return;
                }
                if (
                    this.selectedTenant &&
                    !this.productVariantId &&
                    !this.productTitle &&
                    !this.contentId
                ) {
                    this.$toasted.error(
                        "Please provide at least one more field along with the Tenant for searching Course data.", {
                            icon: "exclamation-triangle",
                            theme: "outline",
                            position: "bottom-center",
                            singleton: true,
                            duration: 3000,
                        }
                    );
                    return;
                }
                this.isLoading = true;
                const courseData = {
                    productVariantID: this.productVariantId || null,
                    ContentID: this.contentId || null,
                    searchString: this.productTitle || null,
                    tenantID: this.selectedTenant ? this.selectedTenant.name : null,
                };
                const response = await GetCourseDataByTenantID(courseData);
                if(response != null){
                    console.log(response);
                    this.$toasted.success(
                        `Fetched Successfully!`, {
                        theme: "outline",
                        position: "bottom-center",
                        duration: 3000,
                    }
                    );
                    this.courseData = response;
                }
                else {
                    throw new Error("There was a problem fetching data. Please try again later.");
                }
            } catch (error) {
                console.error(error);
                this.$toasted.error(
                    error.message || "An unexpected error occurred. Please try again.", {
                            icon: "exclamation-triangle",
                            theme: "outline",
                            position: "bottom-center",
                            singleton: true,
                            duration: 3000,
                        }
                    );
            }finally {
                this.isLoading = false; 
            }
        }
    },
    created() {
        this.getAllTenant();
    },
}
</script>
<style scoped>
.course-support{
    
    min-height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;

}
.field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 300px;
}

.field input,
.field .v-select {
    padding: 0.75rem;
    font-size: 1rem;
    border-radius: 8px;
    border: 1px solid #ccc;
    outline: none;
}

.field input:focus,
.field .v-select--single:focus {
    border-color: #007bff;
}

.fetch-button {
    background-color: #007bff;
    color: #fff;
    padding: 0.75rem;
    font-size: 1rem;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    width: 30%;
    transition: background-color 0.3s;
}

.fetch-button:hover {
    background-color: #0056b3;
}
.field label{
    margin-top: 1rem;
    font-family: 'Times new roman';
    align-self: flex-start;
}
.fetch-parent-button{
    justify-content: center;
}
.row input,.v-select {
    border: 2px solid black !important;
}
</style>